//#region src/constants.ts
const THEME_MODES = [
	"dark",
	"light",
	"system"
];
const THEME_MODE_MUTATION_OBSERVATION_SCOPE = { attributeFilter: ["class"] };
//#endregion
export { THEME_MODES, THEME_MODE_MUTATION_OBSERVATION_SCOPE };

//# sourceMappingURL=constants.js.map